// extracted by mini-css-extract-plugin
export default {"wrapper":"ForgotPass_wrapper__LqktK","selector":"ForgotPass_selector__B2xWN","form":"ForgotPass_form__sDwAl"};